import ApiService from '@/common/api.service'
import AlertService from '@/common/alert.service'

/* eslint-disable */
const getDefaultState = () => {
  return {
    subscriptionData: {},
  }
}

const state = getDefaultState()

const getters = {
}

const mutations = {
  resetOrderState(state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  fetchSubscriptions({}, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.post('Subscription/getall', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  fetchSubscription(ctx, id) {
    return ApiService.get(`Subscription/get/${id}`, {}, this)
      .then(response => {
        if (response.statusCode === 200) {
          ctx.state.subscriptionData = response.result;
        } else {
          AlertService.error(this._vm, response.message)
        }
      })
  },

  saveSubscription({ state }, queryParams) {
    return new Promise((resolve, reject) => {
      ApiService.post('Subscription/save', queryParams, this)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
